import React, {forwardRef} from 'react';
import { useTranslation } from 'react-i18next';

import classes from './TextMessage.module.css';


const TextMessage = forwardRef((props, ref) => {
  const {t} = useTranslation('global');

  const messageClasses = [
    classes[`${props.origin}-message`],
    classes[`${props.position}-message`],
    classes.TextMessage
  ];


  // Reference to help ChatBody component to scroll to the first text message in each 
  // response from the broker
  const scrollReference = (props.position==='First') ? ref : null;

  return (
    <div className={messageClasses.join(' ')} 
      style={props.style} 
      ref={scrollReference}>

      <span className="sr-only">
        {props.origin === 'Bot' ? t('transmitter.bot') : t('transmitter.user')}
      </span>
      <span dangerouslySetInnerHTML={{__html: props.payload.text}} />
    </div>
  )
});



export default TextMessage;